import { serviceStatusLabelParts } from '@/help/serviceStatus'
import type { ServiceStatus } from '@/lib/schemas/db'

/**
 * Renders a service status label, stacking its outcome qualifier (Success /
 * Unsuccessful for the ready-for-collection variants) onto a second, smaller
 * line so the long labels stay compact in tables and dropdowns. Colour and base
 * font are inherited from the parent, so each call site keeps its own styling.
 */
export function StatusLabelStacked({ status }: { status: ServiceStatus }) {
  const { label, qualifier } = serviceStatusLabelParts(status)
  if (!qualifier) return <>{label}</>
  // The label stays the status colour (green = resolved); an unsuccessful
  // outcome is flagged only by a red qualifier beneath it.
  const qualifierClass =
    status === 'ReadyForCollectionUnsuccessful'
      ? 'text-red-600'
      : 'opacity-75'
  return (
    <span className="inline-flex flex-col leading-tight">
      <span>{label}</span>
      <span className={`text-[0.8em] font-normal ${qualifierClass}`}>
        {qualifier}
      </span>
    </span>
  )
}
